/**
 * Uniwersalny model kategorii wykorzystywany w różnych modułach systemu
 * (m.in. do grupowania artykułów oraz kategorii wsparcie komunikacji na stronie Supportu).
 * Opiera się na elastycznej strukturze drzewa (relacje rodzic-dziecko).
 */
export class Category {


  /** Globalnie unikalny identyfikator kategorii. */
  public uuid: string;

  /** Identyfikator kategorii nadrzędnej (Rodzica).
   * Jeśli pole jest puste (null/undefined), oznacza to, że mamy do czynienia
   * z kategorią najwyższego rzędu (Root / Level 0).
   */
  public parentUUID: string;

  /** Poziom zagnieżdżenia w drzewie (np. 0 dla głównej kategorii, 1 dla podkategorii). */
  public level: number;

  /** Nazwa kategorii nadrzędnej.
   * Jest to zabieg optymalizacyjny ułatwiający wyświetlanie w UI
   * bez konieczności odpytywania o rodzica.
   */
  public parentName: string;


  /** Wyświetlana nazwa kategorii. */
  public name: string;

  /** Opcjonalny opis kategorii. */
  public description: string;

  /** Nazwa ikony Ionicicons przypisanej do kategorii.
   */
  public icon: string;


  /** Indeks sortowania całej grupy/rodzica w widoku listy. */
  public parentRowIdx: number;

  /** Indeks sortowania tej konkretnej kategorii w obrębie jej rodzeństwa. */
  public rowIdx: number;


  /** Flaga tymczasowa używana w interfejsie użytkownika (UX).
   * Oznacza element, który został zaznaczony do usunięcia, ale operacja
   * nie została jeszcze zatwierdzona i wysłana do backendu.
   */
  public setToDelete: boolean;

  /** Flaga usunięcia. */
  public deleted: boolean;

}
